import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { PlayerModel } from '../../Models/PlayerModel';

export class UITimeController extends AnimationBaseController {
    $model: PlayerModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('UITimeController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {},
        };
    }

    protected onInitialize(): void {
        this.display.visible = false;
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2 - 700;
    }
}
